/**
 * Slugify para la web de empleos — espejo de server/src/utils/slug.utils.js.
 * El backend re-normaliza y valida siempre; esto es solo para sugerir/previsualizar.
 */
export const slugify = (text) => {
  if (!text || typeof text !== 'string') return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 63)
    .replace(/-$/g, '');
};
